import { defineMessages } from 'react-intl'

const scope = `procurify.platform.comment.components.ChatMenu`

export default defineMessages({
  menuAriaLabel: {
    id: `${scope}.menuAriaLabel`,
    defaultMessage: 'Messaging options',
  },
  messageColleagues: {
    id: `${scope}.messageColleagues`,
    defaultMessage: 'Message colleagues',
  },
  chatButtonAriaLabel: {
    id: `${scope}.chatButtonAriaLabel`,
    defaultMessage: 'Open messaging options',
  },
  commentsCountAriaLabel: {
    id: `${scope}.commentsCountAriaLabel`,
    defaultMessage:
      '{count, plural, one {# internal comment} other {# internal comments}}',
  },
})
